import React, { useState, useEffect, useCallback, useRef } from "react";
import VehicleBlockItem from "./VehicleItem/VehicleBlockItem";
import cookie from "react-cookies";
import useWindowSize from "../../../../../core/hooks/useWindowSize";
import VehicleListGridTable from "./VehicleItem/VehicleListGridTable";

// import "react-perfect-scrollbar/dist/css/styles.css";
// import PerfectScrollbar from "react-perfect-scrollbar";
import PerfectScrollbar from "perfect-scrollbar";
import { isMobile } from "react-device-detect";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import NotificationsOffIcon from "@material-ui/icons/NotificationsOff";
import Badge from '@material-ui/core/Badge';
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Switch from "@material-ui/core/Switch";

const VehicleList = (props) => {
  const {
    details,
    selectedVehicle,
    vehicleType,
    rucAlertCount,
    isAlert,
    searchStr,
    clickedVehicle,
    clickedLicence,
  } = props;




  const [detailView, setdetailView] = useState(true);
  const [buttonText, setbuttonText] = useState(<VisibilityOffIcon />);
  const windowSize = useWindowSize();
  const vehicleShowButton = useRef();
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    if (isMobile) {
      setbuttonText(<VisibilityIcon displayname="VisibilityIcon" />);
    } else {
      setbuttonText(<VisibilityOffIcon displayname="VisibilityOffIcon" />);
    }

    if (cookie.load("detailView") === undefined) {
      const expires = new Date();

      expires.setTime(expires.getTime() + 100 * 86400000);
      //console.log('expires', expires);
      cookie.save("detailView", !detailView, { path: "/", expires });

      setdetailView(true);
    } else {
      //console.log('setdetailview', Boolean(cookie.load('detailView')));
      setdetailView(cookie.load("detailView") === "true" ? true : false);
    }
  }, [detailView]);

  useEffect(() => {
    //when changed item list condition such as search str or vehicletype, open the vehicle list
    if (buttonText.props.displayname === "VisibilityIcon") {
      vehicleShowButton.current.click();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchStr, vehicleType]);

  useEffect(() => {
    try {
      const perfectScrollbar = new PerfectScrollbar(".perfect-scrollbar", {
        wheelSpeed: 0.2,
      });
      perfectScrollbar.update();
    } catch (ex) {
      console.log('err===', ex);
    }
  }, [details]);

  const onClickVehicle = useCallback(
    (item) => {

      if (isMobile) vehicleShowButton.current.click();

      clickedVehicle(item);
    },
    [clickedVehicle]
  );


  const clickedRucAlert = () => {
    if (buttonText.props.displayname === "VisibilityIcon") {
      vehicleShowButton.current.click();
    }
    props.clickedRucAlert();
  };

  const toggleDetailview = () => {
    //console.log('toggleDetailview-start', detailView);

    // const target = event.target;
    // const value = target.name === 'isGoing' ? target.checked : target.value;
    // const name = target.name;

    const expires = new Date();

    expires.setTime(expires.getTime() + 100 * 86400000);
    //console.log('expires', expires);
    cookie.save("detailView", !detailView, { path: "/", expires });

    toggleProcessing();
    //console.log('toggleDetailview-end', detailView);
  };

  const toggleProcessing = async () => {
    props.detailViewChange();
    setdetailView(!detailView);
  };



  const handler = () => {
    //console.log(buttonText) ;
    if (buttonText.props.displayname === "VisibilityOffIcon")
      setbuttonText(<VisibilityIcon displayname="VisibilityIcon" />);
    else setbuttonText(<VisibilityOffIcon displayname="VisibilityOffIcon" />);

    setIsCollapsed(!isCollapsed);

    //Don't use. Due to add collapsed class is animated (loading is slow so event cannot catch)
    // if(vehicleShowButton.current.classList.contains('collapsed') )
    //   setbuttonText('SHOW');
    // else
    //   setbuttonText('HIDE');
  };

  const getStyle = () => {
    //alert(windowSize.height);
    if (!isMobile) {
      return null;
    }

    return {
      minHeight: windowSize.height - 116,
    };
  };

  const getVehicleView = () => {

    if ((isMobile && windowSize.width <= 1025) || !detailView) {
      return (
        <VehicleListGridTable
          details={details}
          clickedVehicle={onClickVehicle}
          clickedLicence={clickedLicence}
        />
      );
    } else {
      return (
        <div
          data-testid="map-blocks"
          className="vehicles main-content-fullheight d-none d-sm-block"
          style={getStyle()}
        >
          <div
            className="perfect-scrollbar"
            style={{ position: "relative", width: "100%", height: "100%" }}
          >
            <div style={{ overflow: "auto" }}>
              {details &&
                details.map((item) => (
                  <VehicleBlockItem
                    key={item.VehicleId}
                    item={item}
                    clickedVehicle={onClickVehicle}
                    isActive={
                      selectedVehicle &&
                        item.VehicleId === selectedVehicle.VehicleId
                        ? true
                        : false
                    }
                  />
                ))}
            </div>
          </div>
        </div>
      );
    }

  }; //, [details, selectedVehicle, windowSize.width]);


  const detailViewControl = () => {
    //useMemo(() => {
    if (isMobile && windowSize.width <= 1025) return null;

    return (
      <div className="col-1" style={{ textAlign: "right", paddingRight: 20 }}>
        <div className="align-bottom">
          <Switch
            size="small"
            checked={detailView}
            onChange={toggleDetailview}
            color="primary"
            name="checkedB"
            inputProps={{ "aria-label": "primary checkbox" }}
          />
          <span style={{ fontSize: "small", color: "#aeaeae" }}>Detailed</span>
        </div>
      </div>
    );
  }; //, [detailView, windowSize.width]);


  const vehicleInfoWrapper = () => {
    return (
      <div className="vhehicle-info-wrapper">
        <div className=" pr-3 vehicle-fix-haeder  justify-content-end align-items-center ">
          <div className="row no-gutters">
            <div className="col-4">
              <div style={{ paddingLeft: 10 }}>
                {/* <button type="button" onClick={handler} className="btn btn-primary btn-sm vehicle-collapse" ref={vehicleShowButton} data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                   
                </button> */}
                <Tooltip title="Vehicles list" aria-label="Vehicles">
                  <IconButton
                    onClick={handler}
                    className="vehicle-collapse"
                    ref={vehicleShowButton}
                    data-toggle="collapse"
                    data-target="#collapseExample"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                    aria-label="Show"
                  >
                    {buttonText}
                  </IconButton>
                </Tooltip>

                {rucAlertCount > 0 && !isAlert && (
                  <Tooltip title="RUC alert show" aria-label="Notifications">

                    <IconButton
                      onClick={clickedRucAlert}
                      color="secondary"
                      aria-label="Notifications"
                    >
                      <Badge badgeContent={rucAlertCount} color="primary">
                        <NotificationsActiveIcon />
                      </Badge>
                    </IconButton>
                  </Tooltip>
                )}

                {rucAlertCount > 0 && isAlert && (
                  <Tooltip title="RUC alert hide" aria-label="Notifications">
                    <IconButton
                      onClick={clickedRucAlert}
                      color="secondary"
                      aria-label="Notifications"
                    >
                      <NotificationsOffIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            </div>
            <div className={`col ${isAlert && "text-danger"}`}>
              <div
                className="p-number"
                style={{ padding: "8px", textAlign: "right", paddingRight: 20 }}
              >
                <span className="">{details ? details.length : 0}</span>
                <span className="p-num-span mt-2 ml-1">
                  {isAlert ? "RUC Alert " : "Vehicles"}
                </span>
              </div>
            </div>
            {detailViewControl()}

          </div>
        </div>
      </div>
    );
  };

  const vehicleWrapper = () => {
    if (isMobile && windowSize.width <= 1025) {
      return (
        <React.Fragment>
          <div
            id="collapseExample"
            className={`${isCollapsed ? "collapse" : "show"} wrap vehicle-detail`}
          >
            {getVehicleView()}
          </div>
          {vehicleInfoWrapper()}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          {vehicleInfoWrapper()}
          <div
            id="collapseExample"
            className={`${isCollapsed ? "collapse" : "show"} wrap vehicle-detail`}
          >
            {getVehicleView()}
          </div>
        </React.Fragment>
      );
    }
  };

  return (
    <div
      className={isMobile && windowSize.width <= 1025 ? "fixed-bottom" : ""}
      style={{ zIndex: 1020 }}
    >
      {vehicleWrapper()}
    </div>
  );
};

export default VehicleList;
